import { Box, Typography } from "@mui/material";


const Section2 = () => {

	return (
		<Box sx={{ height: "100vh", px: 10, display: "flex", justifyContent: "space-between" }} className="div2">
			<Box className="left" sx={{ width: "35%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
				<Typography component="h2"
					sx={{ fontSize: "4rem", fontWeight: 700, lineHeight: 1.3, }}
					className="title">
					<p className="stroke">TRAINING </p>
					PROG.</Typography>
				<Typography sx={{ mt: 4, fontSize: "1.2rem", }} component="p">Drone Destination, together with its sister company, Hubblefly Technologies, a DGCA-approved manufacturer, is a DGCA-authorized Remote Pilot Training Organization that has developed an integrated drone eco-system built around drone manufacturing, certified training, services, and rent a drone.</Typography>

			</Box>
			<Box className="right" sx={{ width: "35%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
				<Typography component="h2"
					sx={{ fontSize: "4rem", fontWeight: 700, lineHeight: 1.3, }}
					className="title">
					<p className="stroke">DRONE </p>
					NETWORK</Typography>
				<Typography sx={{ mt: 4, fontSize: "1.2rem", }} component="p">Drone Destination, together with its sister company, Hubblefly Technologies, a DGCA-approved manufacturer, is a DGCA-authorized Remote Pilot Training Organization that has developed an integrated drone eco-system built around drone manufacturing, certified training, services, and rent a drone.</Typography>
				<Box sx={{ mt: 5, display: "flex", alignItems: "center" }}>
					<Box>
						<Typography sx={{ fontSize: "3rem" }}></Typography>
						<Typography variant="h5"></Typography>
					</Box>
					<Box sx={{ ml: 5 }}>
						<Typography sx={{ fontSize: "3rem" }}></Typography>
						<Typography variant="h5"></Typography>
					</Box>
				</Box>

			</Box>
		</Box>
	)
}

export default Section2;